// extracted by mini-css-extract-plugin
export default {"loading-container":"LoadingIcon_loading-container__-57JX","loader":"LoadingIcon_loader__2Rjju","spin":"LoadingIcon_spin__9G0AI"};